import {
  Bell,
  Bookmark,
  Camera,
  Car,
  ChevronLeft,
  ChevronRight,
  CircleUser,
  Copy,
  Ellipsis,
  Eye,
  EyeOff,
  Flag,
  Footprints,
  Heart,
  House,
  Image,
  LogOut,
  Map,
  Check,
  Crosshair,
  MapPin,
  MessagesSquare,
  Package,
  Pencil,
  Plus,
  Reply,
  Search,
  Send,
  Share2,
  Tag,
  Trash2,
  X,
} from 'lucide-react';

/** Lucide icons — same set/names as Android (`lucide.*`) and iOS (`AppIcon`). */
const ICONS = {
  search: Search,
  home: House,
  house: House,
  plus: Plus,
  heart: Heart,
  bookmark: Bookmark,
  message: MessagesSquare,
  messagesSquare: MessagesSquare,
  user: CircleUser,
  circleUser: CircleUser,
  bell: Bell,
  map: Map,
  mapPin: MapPin,
  mapPinned: MapPin,
  chevron: ChevronRight,
  chevronLeft: ChevronLeft,
  close: X,
  x: X,
  check: Check,
  crosshair: Crosshair,
  send: Send,
  camera: Camera,
  image: Image,
  logout: LogOut,
  logOut: LogOut,
  more: Ellipsis,
  moreHorizontal: Ellipsis,
  share: Share2,
  car: Car,
  walk: Footprints,
  footprints: Footprints,
  shipping: Package,
  tag: Tag,
  flag: Flag,
  eye: Eye,
  eyeOff: EyeOff,
  copy: Copy,
  edit: Pencil,
  pencil: Pencil,
  reply: Reply,
  trash: Trash2,
};

export default function Icon({ name, size = 20, className = '', strokeWidth = 1.8 }) {
  const Cmp = ICONS[name] || Search;
  return (
    <Cmp
      className={`icon ${className}`}
      size={size}
      strokeWidth={strokeWidth}
      absoluteStrokeWidth={false}
      aria-hidden="true"
    />
  );
}
